import {
  AimOutlined,
  BankOutlined,
  BarChartOutlined,
  CarOutlined,
  ClockCircleOutlined,
  DollarOutlined,
  EnvironmentOutlined,
  MobileOutlined,
  NumberOutlined,
  OrderedListOutlined,
  PropertySafetyOutlined,
  SafetyOutlined,
  SendOutlined,
  ShoppingOutlined,
  SyncOutlined,
  TagOutlined,
  TeamOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import {
  MapSvg,
  WarningSvg,
  VehicleSvg,
  DashboardSvg,
  CustomerSvg,
  VoucherSvg,
  DriverSvg,
  ShiftSvg,
  OtherServiceSvg,
} from "../assets/svg/NavigationIcon";

const monitorNavtree = [
  {
    key: "evc-monitor",
    path: `${APP_PREFIX_PATH}/evc-monitor`,
    title: "sidenav.monitor",
    icon: UserOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    submenu: [
      {
        key: "evc-monitor-dashboard",
        path: `${APP_PREFIX_PATH}/evc-monitor/dashboard`,
        title: "sidenav.monitor.dashboard",
        permission: "Dashboard.View",
        iconImg: DashboardSvg,
        breadcrumb: true,
        submenu: []
      },
      {
        key: "evc-monitor-map",
        path: `${APP_PREFIX_PATH}/evc-monitor/map`,
        title: "sidenav.monitor.map",
        permission: "DriverMap.View",
        iconImg: MapSvg,
        breadcrumb: true,
        submenu: []
      },
      {
        key: "evc-monitor-orders",
        path: `${APP_PREFIX_PATH}/evc-monitor/orders`,
        title: "sidenav.monitor.orders",
        permission: "Booking.View",
        iconImg: OrderedListOutlined,
        breadcrumb: true,
        submenu: []
      },
      {
        key: "evc-monitor-trips",
        path: `${APP_PREFIX_PATH}/evc-monitor/trips`,
        title: "sidenav.monitor.trips",
        permission: "Booking.View",
        iconImg: VehicleSvg,
        breadcrumb: true,
        submenu: []
      },
      {
        key: "evc-monitor-shifts",
        path: `${APP_PREFIX_PATH}/evc-monitor/shifts`,
        title: "sidenav.monitor.shifts",
        permission: "DriverShift.View",
        iconImg: ShiftSvg,
        breadcrumb: true,
        submenu: []
      },
      {
        key: "evc-monitor-warning",
        path: `${APP_PREFIX_PATH}/evc-monitor/warning`,
        title: "sidenav.monitor.warning",
        isWarning: true,
        permission: "Alert.View",
        iconImg: WarningSvg,
        breadcrumb: true,
        submenu: []
      },
    ],
  },
];

const fleetNavTree = [
  {
    key: "fleet-management",
    path: `${APP_PREFIX_PATH}/evc-fleet`,
    title: "sidenav.fleet",
    icon: CarOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    submenu: [
      {
        key: "fleet-vehicles",
        path: `${APP_PREFIX_PATH}/evc-fleet/vehicles`,
        title: "sidenav.fleet.vehicles",
        permission: "Vehicle.View",
        iconImg: VehicleSvg,
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "fleet-drivers",
        path: `${APP_PREFIX_PATH}/evc-fleet/drivers`,
        title: "sidenav.fleet.drivers",
        permission: "Driver.View",
        iconImg: DriverSvg,
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "fleet-working-area",
        path: `${APP_PREFIX_PATH}/evc-fleet/working-area`,
        title: "Quản lý tuyến",
        permission: "Route.View",
        iconImg: OtherServiceSvg,
        breadcrumb: true,
        submenu: [],
      },
    ],
  },
];

const commerceNavTree = [
  {
    key: "commerce-management",
    path: `${APP_PREFIX_PATH}/evc-commerce`,
    title: "sidenav.commerce",
    icon: ShoppingOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    submenu: [
      {
        key: "commerce-customers",
        path: `${APP_PREFIX_PATH}/evc-commerce/customers`,
        title: "sidenav.commerce.customers",
        permission: "Customer.View",
        iconImg: CustomerSvg,
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "commerce-vouchers",
        path: `${APP_PREFIX_PATH}/evc-commerce/vouchers`,
        title: "sidenav.commerce.vouchers",
        permission: "Voucher.View",
        iconImg: VoucherSvg,
        breadcrumb: true,
        submenu: [],
      },
    ],
  },
];

const financeNavTree = [
  {
    key: "pricing-finance",
    path: `${APP_PREFIX_PATH}/evc-finance`,
    title: "sidenav.finance",
    icon: ShoppingOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    submenu: [
      {
        key: "evc-pricing",
        path: `${APP_PREFIX_PATH}/evc-finance/pricing`,
        title: "sidenav.finance.pricing",
        iconImg: TagOutlined,
        permission: "PriceService.View",
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "evc-surcharge",
        path: `${APP_PREFIX_PATH}/evc-finance/surcharge`,
        title: "sidenav.finance.surcharge",
        permission: "SurchargeCategory.View",
        iconImg: DollarOutlined,
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "evc-vehicle-expense",
        path: `${APP_PREFIX_PATH}/evc-finance/vehicle-expense`,
        title: "sidenav.finance.vehicle-expense",
        permission: "VehicleExpense.View",
        iconImg: PropertySafetyOutlined,
        breadcrumb: true,
        submenu: [],
      },
    ],
  },
];

const systemNavTree = [
  {
    key: "system-administration",
    path: `${APP_PREFIX_PATH}/evc-system`,
    title: "sidenav.system",
    icon: ShoppingOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    submenu: [
      {
        key: "system-accounts",
        path: `${APP_PREFIX_PATH}/evc-system/accounts`,
        title: "sidenav.system.accounts",
        permission: "UserRole.View",
        iconImg: SafetyOutlined,
        breadcrumb: true,
        submenu: [],
      },
    ],
  },
];

const reportNavTree = [
  {
    key: "reports",
    path: `${APP_PREFIX_PATH}/evc-report`,
    title: "sidenav.report",
    icon: ShoppingOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    submenu: [
      {
        key: "evc-report-orders",
        path: `${APP_PREFIX_PATH}/evc-report/orders`,
        title: "sidenav.report.orders",
        permission: "Report.OrderRevenue.View",
        iconImg: BarChartOutlined,
        breadcrumb: true,
        submenu: []
      },
      {
        key: "evc-report-fleet",
        path: `${APP_PREFIX_PATH}/evc-report/drivers-vehicles`,
        title: "sidenav.report.fleets",
        permission: "Report.VehicleDriver.View",
        iconImg: CarOutlined,
        breadcrumb: true,
        submenu: []
      },
      {
        key: "evc-report-customers",
        path: `${APP_PREFIX_PATH}/evc-report/customers`,
        title: "sidenav.report.customers",
        permission: "Report.Customer.View",
        iconImg: TeamOutlined,
        breadcrumb: true,
        submenu: []
      },
      {
        key: "evc-report-costs",
        path: `${APP_PREFIX_PATH}/evc-report/vehicle-expense`,
        title: "sidenav.report.costs",
        permission: "Report.VehicleExpense.View",
        iconImg: PropertySafetyOutlined,
        breadcrumb: true,
        submenu: []
      },
    ],
  },
];

const settingsNavtree = [
  {
    key: "evc-settings",
    path: `${APP_PREFIX_PATH}/evc-settings`,
    title: "sidenav.settings",
    icon: UserOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    submenu: [
      {
        key: "evc-settings-cancellation-rules",
        path: `${APP_PREFIX_PATH}/evc-settings/cancellation-rules`,
        title: "sidenav.settings.cancellation-rules",
        permission: "Setting.OrderCancel.View",
        iconImg: SyncOutlined,
        breadcrumb: true,
        submenu: []
      },
      {
        key: "evc-settings-drive-matching-rules",
        path: `${APP_PREFIX_PATH}/evc-settings/drive-matching-rules`,
        title: "sidenav.settings.drive-matching-rules",
        permission: "Setting.FindDriver.View",
        iconImg: AimOutlined,
        breadcrumb: true,
        submenu: []
      },
      {
        key: "evc-settings-late-rules",
        path: `${APP_PREFIX_PATH}/evc-settings/late-rules`,
        title: "sidenav.settings.late-rules",
        permission: "Setting.LateRule.View",
        iconImg: ClockCircleOutlined,
        breadcrumb: true,
        submenu: []
      },
      {
        key: "evc-settings-driver-app",
        path: `${APP_PREFIX_PATH}/evc-settings/driver-app`,
        title: "sidenav.settings.driver-app",
        permission: "Setting.DriverApp.View",
        iconImg: MobileOutlined,
        breadcrumb: true,
        submenu: []
      },
      {
        key: "evc-settings-setting-map",
        path: `${APP_PREFIX_PATH}/evc-settings/setting-map`,
        title: "sidenav.settings.setting-map",
        permission: "Setting.Map.View",
        iconImg: EnvironmentOutlined,
        breadcrumb: true,
        submenu: []
      },
      {
        key: "evc-settings-bank-accounts",
        path: `${APP_PREFIX_PATH}/evc-settings/bank-accounts`,
        title: "sidenav.settings.bank-accounts",
        permission: "BankAccount.View",
        iconImg: BankOutlined,
        breadcrumb: true,
        submenu: []
      },
      {
        key: "evc-settings-document-code",
        path: `${APP_PREFIX_PATH}/evc-settings/document-code`,
        title: "sidenav.settings.document-code",
        // permission: "Document.View",
        iconImg: NumberOutlined,
        breadcrumb: true,
        submenu: []
      },
      {
        key: "evc-settings-airlines",
        path: `${APP_PREFIX_PATH}/evc-settings/airlines`,
        title: "sidenav.settings.airlines",
        // permission: "Document.View",
        iconImg: SendOutlined,
        breadcrumb: true,
        submenu: []
      },
    ],
  },
];

const navigationConfig = [
  ...monitorNavtree,
  ...fleetNavTree,
  ...commerceNavTree,
  ...financeNavTree,
  ...reportNavTree,
  ...systemNavTree,
  ...settingsNavtree,
];

export default navigationConfig;
